<template lang="pug">
.check-in(v-if="needShow")
  img.check-in-icon(src="https://m.hellobike.com/resource/helloyun/15979/Xre8PsOPVS.png")
  span(@click="handleClick") {{ !doSignThisTime && !this.repeatSignDesc ? "已签到" : "未签到"}}
  checkin-modal(
    :show.sync="modal",
    :days="days",
    :title="title",
    :active-index="activeIndex",
    :coupon="coupon",
    :currentlyIsVip="currentlyIsVip"
    :bonusTotal="bounty"
    :repeatSignDesc="repeatSignDesc"
    :bountyCountToday="today"
    :didSignToday="didSignToday"
    v-on="$listeners"
  )
  //- do-task-money(
  //-   :show.sync="taskShow"
  //-   :taskList="taskList"
  //- )
</template>

<script>
import { getSignAndRecommend } from '@/api/fuli';
// eslint-disable-next-line no-unused-vars
import { TASK_STATUS_V2 } from '@/const/task';
import {
  // eslint-disable-next-line no-unused-vars
  getTaskListV2, getBountyBasicInfo,
} from '@/api/bounty';
// eslint-disable-next-line no-unused-vars
import { getTokenAndKey, getCityInfo } from '@/utils';
// eslint-disable-next-line no-unused-vars
import { mapTaskV2 } from '@/utils/mappers';
import { env } from '@hb/NBridge/lib/h5';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import Toast from '@/components/toast';
// eslint-disable-next-line no-unused-vars
import { getVersion } from '@/utils/systemCode';
import CheckinModal from './checkin-modal';
// import DoTaskMoney from './dotask-money';

const ACTIVE_ICON = 'https://m.hellobike.com/resource/AppPlatformH5/fuli/lX02rwjiuTTXbTgdXMbco.png';
const CHECKIN_ACTIVE_ICON = 'https://m.hellobike.com/resource/AppPlatformH5/fuli/cPdfYpajOmEqMttQ46R5a.png';
const INACTIVE_ICON = 'https://m.hellobike.com/resource/AppPlatformH5/fuli/McuKtqFNzr0bhHNNseHY8.png';
const CHECKIN_INACTIVE_ICON = 'https://m.hellobike.com/resource/AppPlatformH5/fuli/sPLJzvaGM5RFPOfzLNTap.png';
const RED_ICON = 'https://m.hellobike.com/resource/helloyun/15979/daAZSqJK3-.png';

const mapper = (v) => {
  const {
    title, bonusList, bountyCountToday, doSignThisTime, bountyGood, currentlyIsVip, repeatSignDesc, didSignToday,
  } = v;

  return {
    title,
    today: bountyCountToday,
    doSignThisTime,
    days: (bonusList || []).map((item, index) => {
      const { icon, checkIcon } = (() => {
        if (!item.didSign) {
          if (item.multipleDesc) {
            return {
              icon: RED_ICON,
              checkIcon: RED_ICON,
            };
          }
          return {
            icon: INACTIVE_ICON,
            checkIcon: CHECKIN_INACTIVE_ICON,
          };
        }
        return {
          icon: ACTIVE_ICON,
          checkIcon: CHECKIN_ACTIVE_ICON,
        };
      })();

      return {
        text: `第${index + 1}天`,
        checked: item.didSign,
        amount: item.bonusCount,
        icon,
        checkIcon,
        class: (item.multipleDesc && !item.didSign) ? ['red'] : [],
      };
    }),
    coupon: bountyGood,
    needShow: true,
    currentlyIsVip,
    repeatSignDesc,
    didSignToday,
  };
};

export default {
  components: {
    CheckinModal,
    // DoTaskMoney,
  },
  props: {
    bounty: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      days: [],
      title: '签到赚奖励金',
      modal: false,
      taskShow: false,
      doSignThisTime: false,
      diversion: null,
      env,
      coupon: null,
      needShow: false,
      currentlyIsVip: false,
      repeatSignDesc: null,
      // taskList: [],
      // canOpenTask: false,
      today: '',
      didSignToday: false,
    };
  },
  computed: {
    activeIndex() {
      const index = [...(this.days || [])].reverse().findIndex((v) => v.checked);
      if (index !== -1) {
        return (this.days || []).length - index - 1;
      }
      return -1;
    },
  },
  watch: {
    modal(v) {
      if (!v && this.doSignThisTime) {
        this.doSignThisTime = false;
      }
      if (v && this.repeatSignDesc) {
        Toast.show(this.repeatSignDesc);
      }
    },
  },
  mounted() {
    this.start();
  },
  methods: {
    async start() {
      const { token } = await getTokenAndKey();
      const data = await getSignAndRecommend({ token })
        .then((v) => v.data || null)
        .catch(() => null)
        .then((v) => { this.$emit('bounty'); return v; });
      if (!data) {
        return;
      }
      Object.assign(this, mapper(data));
      if (this.doSignThisTime || this.repeatSignDesc) {
        // await this.getTaskContent();
        this.modal = true;
        if (this.repeatSignDesc) {
          Toast.show(this.repeatSignDesc);
        }
      }
    },
    // async getTaskContent(){
    //   const [
    //     { token }, cityInfo,
    //   ] = await Promise.all([getTokenAndKey(), getCityInfo()]);
    //   const [basic, task] = await Promise.all([
    //     getBountyBasicInfo({ token, pointType: 1 }).then((v) => v.data).catch(() => null),
    //     getTaskListV2({
    //       token,
    //       channelId: env.platformCode,
    //       sceneNameEn: 'platform_points',
    //       subSceneNameEn: 'student_center',
    //       taskStatusList: [TASK_STATUS_V2.INIT, TASK_STATUS_V2.RUNNING],
    //       queryUnrewardedTasks: true,
    //       version: await getVersion(),
    //       ...cityInfo,
    //     }).then((v) => v.data).catch(() => null),
    //   ]);
    //   if (task && task.taskList) {
    //     this.taskList = task.taskList;
    //     this.canOpenTask = task.taskList.length ? true : false;
    //     console.log('taskList',this.taskList)
    //   }
    // },
    taskOpen() {
      this.taskShow = true;
    },
    async handleClick() {
      // await this.getTaskContent();
      UBT.clickButton({
        pageId: 'welfare_new',
        buttonName: 'already_sign',
        categoryId: 'platform',
        businessInfo: {},
      });
      this.modal = !this.modal;
    },
  },
};
</script>

<style lang="less" scoped>
.check-in {
  position: absolute;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 0.14rem 0 0 0.14rem;
  right: 0;
  top: 0.18rem;
  font-weight: 500;
  color: #fff;
  line-height: 0.12rem;
  font-size: 0.12rem;
  padding: 0.09rem 0.06rem 0.06rem 0.12rem;
  overflow: hidden;

  .check-in-icon {
    max-width: 0.12rem;
    max-height: 0.1rem;
    margin-right: 0.06rem;
  }
}
</style>
